
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';

function CopyCard({ trade_id, image, name, winrate, profit, win, loss, copy, price }) {
    const { user } = useUser();
    const [copied, setCopied] = useState(copy);
    const [loading, setLoading] = useState(false);
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);

    const ValidateCopy = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/copytrade.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_copy: true, trade_id: trade_id, price: price, copied : !copied })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            setLoading(false);
            toast.success(data.result);
            setCopied(!copied);
          }else{
            toast.error(data.message);
          }
        })
        .catch(err => {
          console.error(err)
          setLoading(false);
          toast.error('There was an issue processing your deposit.')
        })
    }
    return (
      <div className="mycard mb-4">
        <div className="d-flex align-items-center mb-5">
            <div className="d-flex align-items-center justify-content-center overflow-hidden rounded-circle" style={{width: '50px', height: '50px'}}>
                {image}
            </div>
            <p className="ms-3 text-white fw-bold mb-0" style={{fontSize: '18px'}}>{name}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Win rate</p>
            <p className="mb-0 fw-bold text-white">{winrate}%</p>
        </div>
        <hr style={{color: '#ffffff47'}}/>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Profit share</p>
            <p className="mb-0 fw-bold text-white">{profit}%</p>
        </div>
        <hr style={{color: '#ffffff47'}}/>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Wins</p>
            <p className="mb-0 fw-bold text-white">{win}</p>
        </div>
        <hr style={{color: '#ffffff47'}}/>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Losses</p>
            <p className="mb-0 fw-bold text-white">{loss}</p>
        </div>
        <hr style={{color: '#ffffff47'}}/>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Price</p>
            <p className="mb-0 fw-bold text-white">{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</p>
        </div>
        <div className={`myBtn ${copied?'bg-danger':'bg-prime'} w-100 text-center mt-4`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={ValidateCopy}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:copied?'Cancel':'Copy'}</div>
      </div>
    )
  }
  
  export default CopyCard